module.exports = __webpack_public_path__ + "img/icon-search.126231bb.svg";